namespace GeniuzPOS.RefundReasonReport {
    export namespace ReportRefundReasonSumBillService {
        export const baseUrl = 'RefundReasonReport/ReportRefundReasonSumBill';

        export declare function Create(request: Serenity.SaveRequest<ReportRefundReasonSumBillRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportRefundReasonSumBillRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportRefundReasonSumBillRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportRefundReasonSumBillRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "RefundReasonReport/ReportRefundReasonSumBill/Create",
            Update = "RefundReasonReport/ReportRefundReasonSumBill/Update",
            Delete = "RefundReasonReport/ReportRefundReasonSumBill/Delete",
            Retrieve = "RefundReasonReport/ReportRefundReasonSumBill/Retrieve",
            List = "RefundReasonReport/ReportRefundReasonSumBill/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportRefundReasonSumBillService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
